import type { FC, MouseEventHandler, ReactNode } from 'react';

import { ButtonKinds } from 'types/button';
import { twMergeClsx } from 'utils/tw-with-clsx';
import { DynamicTagButton } from 'views/shared/dynamic-tag-button';
import { SpinnerIcon } from 'views/shared/spinner-icon';

interface ButtonProps {
  children: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  kind?: ButtonKinds;
  isLoading?: boolean;
  disabled?: boolean;
}

const buttonStyles =
  'active:bg-base-blue-400 w-full h-[42px] md:h-12 hover:bg-base-blue-200 rounded-xsmall md:rounded-medium bg-base-blue-100 px-5 py-2 md:py-3 text-sm font-bold text-white transition-colors disabled:bg-base-gray-400';
const buttonSuccessStyles =
  'bg-[transparent] hover:bg-white/10 active:bg-white/20 ring-1 ring-white';
const buttonWhiteStyles = 'bg-white text-base-green-100 hover:bg-white/90 active:bg-white/80';

const Button: FC<ButtonProps> = ({
  children,
  onClick,
  className,
  kind = ButtonKinds.default,
  isLoading,
  disabled,
}) => {
  const classes = twMergeClsx(
    buttonStyles,
    kind === ButtonKinds.success && buttonSuccessStyles,
    kind === ButtonKinds.secondary && buttonWhiteStyles,
    className,
  );

  return (
    <DynamicTagButton disabled={disabled || isLoading} className={classes} onClick={onClick}>
      {isLoading ? <SpinnerIcon /> : children}
    </DynamicTagButton>
  );
};

export { Button };
